import {colors} from '../../defaultSettings';
import {absCenterY} from '@xpertdox_js/xdstyle';

export default {
  container: {
    width: '200px',
    background: colors.bg.headerTab,
    color: colors.headerTabText,
    borderBottom: '1px solid ' + colors.headerMenuBorderDrk,
    borderLeft: '1px solid ' + colors.headerTabBorder,
    padding: '2px 4px',
    fontSize: '.9rem',
    height: '100%',
    position: 'absolute',
    height: '20px',
    left: 0,
    right: 'auto',
  },
  defaultText: {
    ...absCenterY,
    fontSize: '1rem',
    left: '2px', right: 'auto',
  },
  queryText: {
    ...absCenterY,
    fontSize: '1rem',
    right: '6px', left: 'auto',
    maxWidth: '50%',
    overflowX: 'hidden'
  },
  textWrap: {
    width: '180px',
    position: 'absolute',
    top: 0, left: 0, right: 'auto',
    height: '100%',
  },
  clearBtn: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 'auto',
    padding: 0,
    height: '100%',
    width: '24px',
    background: 'none',
    fill: colors.headerTabText,
    borderLeft: '1px solid ' + colors.headerTabBorder,
    borderRight: '1px solid ' + colors.headerTabBorder,
  },
  clearBtnHov: {
    fill: colors.stop,
    background: colors.headerTabBorder,
  },
  svg: {
    width: '22px',
    height: '22px',
    display: 'block',
    transform: 'translateY(-1px)'
  }
}
